import React, { useEffect, useState } from 'react';
import CollapseCard from '../Components/CollapseCard';
import { getAllVendors } from '../Service/VendorService';
import { getAdvanceByVendorId, getAllAdvance } from '../Service/AdvanceService';
import { useToast } from '../Components/toast/ToastProvider';
import VendorAdvanceFilter from '../Components/VendorAdvanceFilter';
import Main from '../Components/Main';
import PageContainer from '../Components/PageContainer';
import { Button, Table } from 'react-bootstrap';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from 'react-feather';
import { formatDate } from '../config/function';
import { getPaymentHistoryByAdvance } from '../Service/VendorAdvanceService';

const VendorAdvanceReport = () => {
    const [filters, setFilters] = useState({ vendor_id: '', status: '' });
    const [vendors, setVendors] = useState([]);
    const [advanceData, setAdvanceData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [allAdvanceData, setAllAdvanceData] = useState([]);
    const toast = useToast();

    useEffect(() => {
        fetchVendors();
        // fetchAdvanceByVendorId();
    }, []);

    const fetchVendors = async () => {
        try {
            const res = await getAllVendors();
            setVendors(res.data);
        } catch (err) {
            toast(err.message || 'Failed to fetch vendors', 'ERROR');
        }
    };
    const fetchAdvanceByVendorId = async (vendor_id) => {
        try {
            if (!vendor_id) {
                setAdvanceData([]);
                return;
            }
            const res = await getAdvanceByVendorId(vendor_id);
            const data = Array.isArray(res.data) ? res.data : [];
            setAdvanceData(data);
            setAllAdvanceData(data);
        } catch (err) {
            toast(err.message || 'Failed to advance by vendor_id');
        }
    };

    const handleFilterChange = (field, value) => {
        setFilters((prev) => {
            const updated = { ...prev, [field]: value };


            if (field === "vendor_id") {
                fetchAdvanceByVendorId(value);
            }


             if (field === "status") {
            const validStatus = ["open", "closed"];

            if (!updated.vendor_id) {
                toast("Select a vendor first", "WARNING");
                return updated;
            }

            if (!validStatus.includes(value.toLowerCase())) {
                return updated; 
            }

            applyStatusFilter(value);
        }

            return updated;
        });
    };

    const applyStatusFilter = (status) => {
        if (!status) {
            setAdvanceData(allAdvanceData);
            return;
        }

        const filtered = allAdvanceData.filter((item) => {
            const itemStatus = (item.status || "").toLowerCase().trim();
            const filterStatus = status.toLowerCase().trim();
            return itemStatus.includes(filterStatus);
        });

        if (filtered.length === 0) {
            toast("No records found for selected status", "INFO");
        }

        setAdvanceData(filtered);
    };
    const handleReset = () => {
        setFilters({ vendor_id: '', status: '' });
        // setAdvanceData(originalData);
        setAdvanceData([]);
        setAllAdvanceData([]);
    }

    const addPDFHeader = (doc, pageWidth) => {
        const logo = new Image();
        logo.src = "/img/asa_logo.png";

        const logoWidth = 18;
        const logoHeight = 18;
        const spacing = 5;
        const headerText = "ASA Transport";
        const subHeaderText = "Mannargudi";


        const headerWidth = doc.getTextWidth(headerText);
        const subHeaderWidth = doc.getTextWidth(subHeaderText);
        const totalWidth = logoWidth + spacing + Math.max(headerWidth, subHeaderWidth);
        const startX = (pageWidth - totalWidth) / 2;

        try {
            doc.addImage(logo, "PNG", startX, 8, logoWidth, logoHeight);
        } catch (e) {
            console.warn("Logo load skipped (small size optimization)");
        }

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(headerText, startX + logoWidth + spacing, 14);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(subHeaderText, startX + logoWidth + spacing, 20);
    };


    const generateTablePDF = () => {
        if (advanceData.length === 0) {
            toast("No records to export", "WARNING");
            return;
        }
        const capitalize = (str) => { if (!str) return "N/A"; return str.toLowerCase().split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" "); };

        const doc = new jsPDF({ orientation: "potrait", compress: true });
        const pageWidth = doc.internal.pageSize.getWidth();

        addPDFHeader(doc, pageWidth);


        doc.setFontSize(13);
        doc.setFont("helvetica", "bold");
        doc.text("Vendor Advance Details", pageWidth / 2, 35, { align: "center" });


        const selectedVendor = filters.vendor_id
            ? vendors.find(v => v.id === parseInt(filters.vendor_id))
            : null;

        const vendorName = capitalize(selectedVendor?.name || "All Vendors");
        const vendorMobile = selectedVendor?.contact_number || "-";
        const vendorAddress = capitalize(selectedVendor?.location || "-");

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);

        let y = 45;
        doc.text(`Vendor Name: ${vendorName}`, 14, y);
        if (selectedVendor) {
            y += 6;
            doc.text(`Mobile: ${vendorMobile}`, 14, y);
            y += 6;
            doc.text(`Address: ${vendorAddress}`, 14, y);
        }


        const tableColumn = [
            "S.No",
            "Date",
            "Type",
            "Advance Amount",
            "Total Deduction",
            "Balance Amount",
            "Status"
        ];

        const tableRows = advanceData.map((adv, i) => [
            i + 1,
            adv.date || "N/A",
            adv.type || "N/A",
            Number(adv.advance_amount || 0).toFixed(2),
            Number(adv.total_deduction || 0).toFixed(2),
            Number(adv.balance_amount || 0).toFixed(2),
            adv.status || "N/A",
        ]);

        autoTable(doc, {
            startY: y + 10,
            head: [tableColumn],
            body: tableRows,
            theme: "grid",
            styles: {
                fontSize: 8,
                cellPadding: 2,
                textColor: [0, 0, 0],
                lineColor: [0, 0, 0],
                lineWidth: 0.2,
            },
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                lineColor: [0, 0, 0],
                lineWidth: 0.2,
                fontStyle: "bold",
            },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 20 },
                2: { cellWidth: 20 },
                3: { cellWidth: 30 },
                4: { cellWidth: 35 },
                5: { cellWidth: 30 },
            },
        });


        const pdfOutput = doc.output("arraybuffer");
        const fileSizeKB = pdfOutput.byteLength / 1024;
        const fileSizeText =
            fileSizeKB > 1024
                ? `${(fileSizeKB / 1024).toFixed(2)} MB`
                : `${fileSizeKB.toFixed(2)} KB`;

        // toast(`PDF generated (${fileSizeText})`, "SUCCESS");

        const fileName = selectedVendor
            ? `Vendor_Advance_Report_${vendorName}.pdf`
            : "Vendor_Advance_Report_All_Vendors.pdf";

        doc.save(fileName);
    };

    const generateTripDetailsPDF = async (adv) => {
        const doc = new jsPDF({ orientation: "portrait", compress: true });
        const pageWidth = doc.internal.pageSize.getWidth();
        addPDFHeader(doc, pageWidth);

        const capitalize = (str) => {
            if (!str) return "N/A";
            return str.toLowerCase().split(" ")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" ");
        };

        const vendor = vendors.find(v => v.id === adv.vendor_id);


        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);
        doc.text("Vendor Advance List", pageWidth / 2, 45, { align: "center" });


        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(`Date: ${formatDate(adv.date)}`, 20, 59);


        const leftDetails = [
            { label: "Name", value: capitalize(vendor?.name) },
            { label: "Type", value: adv.type },
            { label: "Status", value: adv.status }
        ];

        const rightDetails = [
            { label: "Advance Amount", value: adv.advance_amount?.toFixed(2) },
            { label: "Total Deduction", value: adv.total_deduction?.toFixed(2) },
            { label: "Balance Amount", value: adv.balance_amount?.toFixed(2) }
        ];

        let leftY = 72;
        let rightY = 72;
        doc.setFontSize(11);

        leftDetails.forEach((d) => {
            doc.setFont("helvetica", "bold");
            doc.text(`${d.label}:`, 25, leftY);
            doc.setFont("helvetica", "normal");
            doc.text(String(d.value || "N/A"), 50, leftY);
            leftY += 10;
        });

        rightDetails.forEach((d) => {
            doc.setFont("helvetica", "bold");
            doc.text(`${d.label}:`, 120, rightY);
            doc.setFont("helvetica", "normal");
            doc.text(String(d.value || "0.00"), 160, rightY);
            rightY += 10;
        });

        let paymentHistory = [];
        try {
            const res = await getPaymentHistoryByAdvance(adv.id);
            paymentHistory = res.data || [];
        } catch (err) {
            console.warn("Failed to fetch payment history", err);
        }

        const sectionY = Math.max(leftY, rightY) + 20;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text("Payment History", pageWidth / 2, sectionY - 5, { align: "center" });


        if (paymentHistory.length === 0) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.text(
                "No Payment History Available",
                pageWidth / 2,
                sectionY + 5,
                { align: "center" }
            );
        }
        else {
            const tableColumn = [
                "S.No",
                "Date",
                adv.type === "Normal"
                    ? "Normal Advance Deduction"
                    : "Receipt Advance Deduction"
            ];

            let phRows = paymentHistory.map((p, index) => {

                let deduction = adv.type === "Normal"
                    ? Number(p.nor_advance_deduction ?? 0)
                    : Number(p.res_advance_deduction ?? 0);

                return {
                    sno: index + 1,
                    date: formatDate(p.payment_date),
                    deduction: deduction
                };
            });

            phRows = phRows.filter(row => row.deduction > 0);

            const finalRows = phRows.map(row => [
                row.sno,
                row.date,
                row.deduction.toFixed(2)
            ]);

            autoTable(doc, {
                startY: sectionY + 10,
                head: [tableColumn],
                body: finalRows,
                theme: "grid",
                styles: {
                    fontSize: 10,
                    cellPadding: 2,
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.2,
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.2,
                    fontStyle: "bold",
                }
            });
        }
        doc.save(`Vendor_Advance_${vendor?.name || "Report"}.pdf`);
    };
    return (
        <Main>
            <PageContainer>
                <CollapseCard title="Vendor Advance Filter">
                    <VendorAdvanceFilter
                        filters={filters}
                        vendors={vendors}
                        onFilterChange={handleFilterChange}
                        // onFind={}
                        onReset={handleReset}
                        fetchAdvanceByVendorId={fetchAdvanceByVendorId}
                    />
                </CollapseCard>

                <CollapseCard title="Vendor Advance Details">
                    <Table size="sm">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Vendor Name</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Total Deduction</th>
                                <th>Balance Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {advanceData.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                advanceData.map((a, index) => {
                                    const vendor = vendors.find((v) => v.id === a.vendor_id);
                                    return (
                                        <tr key={a.id}>
                                            <td>{index + 1}</td>
                                            <td>{formatDate(a.date || '-')}</td>
                                            <td>{vendor ? vendor.name : '-'}</td>
                                            <td>{a.type}</td>
                                            <td >{a.advance_amount?.toFixed(2)}</td>
                                            <td >{a.total_deduction?.toFixed(2)}</td>
                                            <td>{Number(a.balance_amount || 0).toFixed(2)}</td>
                                            <td>{a.status || '-'}</td>
                                            <td><Button variant='primary'
                                                size='sm'
                                                onClick={() => generateTripDetailsPDF(a)}>
                                                PDF
                                            </Button></td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </CollapseCard>
                <div className="d-flex justify-content-end mb-2 mt-2">
                    <Button variant="success" size="sm" onClick={generateTablePDF}>
                        <Download /> Download PDF
                    </Button>
                </div>
            </PageContainer>
        </Main>
    );
};

export default VendorAdvanceReport;
